// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"8ee2abef","303":"75ffd159","453":"84e7eb16","602":"d4b76035"}[chunkId] + ".chunk.js";
};